import { Pipe, PipeTransform } from '@angular/core';

import { SharedService } from 'src/app/core/services/shared.service';

@Pipe({
  name: 'offerType'
})
export class OfferTypePipe implements PipeTransform {
  constructor(private sharedService: SharedService) {}

  transform(value: string): string {
    const offerTypes = {
      buy: { en: 'Buy', no: 'Kjøp' },
      sell: { en: 'Sell', no: 'Selg' }
    };
    return offerTypes[value.toLocaleLowerCase()][this.sharedService.language];
  }
}
